<p-toast></p-toast>

<div [ngClass]="{'page-ltr': currentLang === 'en'}">

    <div class="package-contents-management-container">
        <div class="d-flex top-side">
            <div class="header">
                <div class="package-contents-management-title">
                    <span>{{ 'ADMINISTRATION.MANAGE_PACKAGE_CONTENTS.MENU_ITEM_LABEL' | translate | packageTitle }}</span>
                </div>
            </div>

            <div class="actions">
                <div class="search-filter d-flex">
                    <div class="search-icon-2">
                        <i class="fas fa-search" [ngClass]="{'fa-rotate-90' : currentLang === 'ar'}"></i>
                    </div>
                    <div class="search-input">
                        <input type="text" placeholder="{{ 'GENERAL.SEARCH' | translate }}..." appInputDebounced
                               (inputDebounced)="onSearch()" [(ngModel)]="searchContent">
                    </div>
                </div>

                <div class="add-action" (click)="addPackageContent()"
                     [ngClass]="{'disabled-btn disabled': isLoading}">
                    <div class="icon">
                        <i class="fas fa-plus"></i>
                    </div>
                    <div class="label">
                        <span>{{ 'ADMINISTRATION.MANAGE_PACKAGE_CONTENTS.ACTIONS.ADD' | translate }}</span>
                    </div>
                </div>
            </div>

        </div>
        <div class="data-table package-contents-data-table">
            <div class="table-body-container overflow-auto" (scroll)="onScroll($event)">
                <p-table [value]="packageContents" [responsive]="true" scrollHeight="auto"
                         styleClass="table-container data-p-table">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{'ADMINISTRATION.MANAGE_PACKAGE_CONTENTS.FORM.NAME' | translate}}</th>
                            <th>{{'ADMINISTRATION.MANAGE_PACKAGE_CONTENTS.FORM.ARABIC_NAME' | translate}}</th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <div class="empty-content">
                            <app-no-data-available-component></app-no-data-available-component>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="body" let-content>
                        <tr>
                            <td>
                                {{ content.name }}
                            </td>
                            <td>
                                {{ content.arabicName }}
                            </td>
                            <td>
                                <div class="row-actions">
                                    <img
                                            (click)="setPackageContent(content)"
                                            style="padding: 10px"
                                            placement="{{currentLang === 'en' ? 'left': 'right'}}"
                                            autoClose="outside"
                                            #rowActionsPopOver="ngbPopover"
                                            [ngbPopover]="rowActions"
                                            src="../../assets/icons/containers-management/menu.svg"
                                            alt=""
                                    />
                                </div>
                                <ng-template #rowActions let-close="close">
                                    <div class="row-actions-container">
                                        <div class="row action"
                                             (click)="editPackageContent(triggeredPackageContent, rowActionsPopOver)">
                                            <div class="icon">
                                                <img class="margin-left-10 edit-button"
                                                     src="../../assets/icons/containers-management/edit.svg"
                                                     alt="icon"/>
                                            </div>
                                            <div class="row-action-hidden-space"></div>
                                            <div class="label">{{ 'ADMINISTRATION.MANAGE_PACKAGE_CONTENTS.ACTIONS.EDIT' | translate }}</div>
                                        </div>
                                        <div class="row action remove-action"
                                             (click)="deletePackageContent(triggeredPackageContent, rowActionsPopOver)">
                                            <div class="icon">
                                                <img src="../../assets/icons/containers-management/remove_vechile.svg"
                                                     alt="icon"/>
                                            </div>
                                            <div class="row-action-hidden-space"></div>
                                            <div class="label">{{ 'ADMINISTRATION.MANAGE_PACKAGE_CONTENTS.ACTIONS.DELETE' | translate }}</div>
                                        </div>
                                    </div>
                                </ng-template>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <app-skeleton-loader [type]="1" *ngIf="isLoading"></app-skeleton-loader>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>
